export const dialogInputStopPropagation = {
  onKeyDown: <E extends { stopPropagation: () => void }>(e: E) => e.stopPropagation()
}
